import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import SketchTool from '../../SketchTool';
import styles from './FormDefinitionInput.styles';
import Checkbox from './InputTypes/Checkbox';
import DateInput from './InputTypes/DateInput';
import HyperLink from './InputTypes/HyperLink';
import MultiSelect from './InputTypes/MultiSelect';
import RadioGroup from './InputTypes/RadioGroup';
import ReadOnly from './InputTypes/ReadOnly';
import Select from './InputTypes/Select';
import TextField from './InputTypes/TextField';
import ValuationCalculation from './InputTypes/ValuationCalculation';

const propTypes = {
  classes: PropTypes.object.isRequired,
  checkIfAnswerTriggersNewFormHeader: PropTypes.func.isRequired,
  formDefinition: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  imageToEdit: PropTypes.object,
  removeAnswers: PropTypes.func.isRequired,
  saveAnswers: PropTypes.func.isRequired,
  updateFormHeaders: PropTypes.func.isRequired,
};

const FormDefinitionInput = ({
  classes,
  checkIfAnswerTriggersNewFormHeader,
  formDefinition,
  isReadOnly,
  imageToEdit,
  removeAnswers,
  saveAnswers,
  updateFormHeaders,
  inputStyle,
}) => {
  switch (formDefinition.answerType) {
    case 'Check Box':
      return (
        <Checkbox
          key={formDefinition.formDefinitionId}
          checkIfAnswerTriggersNewFormHeader={checkIfAnswerTriggersNewFormHeader}
          formDefinition={formDefinition}
          isReadOnly={isReadOnly}
          imageToEdit={imageToEdit}
          removeAnswers={removeAnswers}
          saveAnswers={saveAnswers}
          updateFormHeaders={updateFormHeaders}
          inputStyle={inputStyle}
        />
      );
    case 'Date':
    case 'Date MMYY':
    case 'Date YY':
    case 'Date YYYY':
      return (
        <DateInput
          key={formDefinition.formDefinitionId}
          formDefinition={formDefinition}
          isReadOnly={isReadOnly}
          imageToEdit={imageToEdit}
          removeAnswers={removeAnswers}
          saveAnswers={saveAnswers}
          updateFormHeaders={updateFormHeaders}
          inputStyle={inputStyle}
        />
      );
    case 'Hyperlink':
      return <HyperLink key={formDefinition.formDefinitionId} formDefinition={formDefinition} />;
    case 'Multi Select':
      return (
        <MultiSelect
          key={formDefinition.formDefinitionId}
          checkIfAnswerTriggersNewFormHeader={checkIfAnswerTriggersNewFormHeader}
          formDefinition={formDefinition}
          isReadOnly={isReadOnly}
          imageToEdit={imageToEdit}
          removeAnswers={removeAnswers}
          saveAnswers={saveAnswers}
          updateFormHeaders={updateFormHeaders}
          inputStyle={inputStyle}
        />
      );
    case 'True/False':
    case 'Yes/No':
      return (
        <RadioGroup
          key={formDefinition.formDefinitionId}
          checkIfAnswerTriggersNewFormHeader={checkIfAnswerTriggersNewFormHeader}
          formDefinition={formDefinition}
          isReadOnly={isReadOnly}
          imageToEdit={imageToEdit}
          removeAnswers={removeAnswers}
          saveAnswers={saveAnswers}
          updateFormHeaders={updateFormHeaders}
          inputStyle={inputStyle}
        />
      );
    case 'Single Select':
      return (
        <Select
          key={formDefinition.formDefinitionId}
          checkIfAnswerTriggersNewFormHeader={checkIfAnswerTriggersNewFormHeader}
          formDefinition={formDefinition}
          isReadOnly={isReadOnly}
          imageToEdit={imageToEdit}
          removeAnswers={removeAnswers}
          saveAnswers={saveAnswers}
          updateFormHeaders={updateFormHeaders}
          inputStyle={inputStyle}
        />
      );
    case 'Header':
      // Section header: title is rendered by FormDefinition, no input
      return null;
    case 'Read Only':
      return <ReadOnly key={formDefinition.formDefinitionId} formDefinition={formDefinition} inputStyle={inputStyle} />;
    case 'Sketch':
      return <SketchTool />;
    case 'Address':
    case 'Currency':
    case 'Float':
    case 'Number of items':
    case 'Percentage':
    case 'TextBox':
    case 'TextArea':
      return (
        <TextField
          key={formDefinition.formDefinitionId}
          formDefinition={formDefinition}
          isReadOnly={isReadOnly}
          imageToEdit={imageToEdit}
          removeAnswers={removeAnswers}
          saveAnswers={saveAnswers}
          updateFormHeaders={updateFormHeaders}
          inputStyle={inputStyle}
        />
      );
    case 'Valuation Calculation':
      return (
        <ValuationCalculation
          key={formDefinition.formDefinitionId}
          formDefinition={formDefinition}
          isReadOnly={isReadOnly}
          imageToEdit={imageToEdit}
          removeAnswers={removeAnswers}
          saveAnswers={saveAnswers}
          inputStyle={inputStyle}
        />
      );
    default:
      console.log('This answer type is not recogized.');
      return null;
  }
};

FormDefinitionInput.propTypes = propTypes;
export default withStyles(styles)(FormDefinitionInput);
